// extracted by mini-css-extract-plugin
export var actionIcon = "_kf-0";